(ns manage.content-variant-page.view.list
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            [common.widgets.layout :refer [stack-divider]]
            [uix.core :as uix :refer [$]]))

(defn list-item-details
  [& children]
  (into [:> Stack {:divider ($ stack-divider)
                   :sx {:mx -2 :my -1}}] children))

(defn list-item-element
  [& children]
  (into [:> Stack {:px 2 :py 1}] children))

(defn configure-button
  [on-click label]
  [:> Button {:start-icon ($ Icon "settings")
              :on-click on-click
              :modifier :tertiary
              :sx {:align-self "flex-start"}}
   label])
